import axios, { AxiosResponse } from "axios";
import { getToken } from "./authApi";
import { ApiResponse, BaseResponseWithData, baseUrl, GetParams, getWithAuthAndParams, Guid, postWithAuth } from "./baseApi";

export interface TvGuideCell {
    start: string
    end: string
    title: string
    scheduledStreamListId: Guid
    streamId: Guid
}

export type PlayerTvGuideRow = {
    date: string
    spans: TvGuideCell[]
}

export type PlayerTvGuide = {
    dates: PlayerTvGuideRow[]
}

export type DayModeTvGuidePlayer = {
    playerName: string
    spans: TvGuideCell[]
}

export type DayModeTvGuide = {
    players: DayModeTvGuidePlayer[]
}

type DayModeTvGuideRequest = {
    playerIds: Guid[]
    date: string
}

export const getPlayerTvGuide = async(playerId: Guid, start: string, end: string) : Promise<ApiResponse<BaseResponseWithData<PlayerTvGuide>>> => {
    const params = new GetParams();
    params.Add("playerId", playerId);
    params.Add("startTime", start);
    params.Add("endTime", end);
    const response = await getWithAuthAndParams<BaseResponseWithData<PlayerTvGuide>>(`${baseUrl}tv-guided-look`, params);

    return response;
}

export const getDayModeTvGuide = async(playerIds: Guid[], date: string) : Promise<ApiResponse<BaseResponseWithData<DayModeTvGuide>>> => {
    const request = { playerIds, date };
    const response = await postWithAuth<DayModeTvGuideRequest, BaseResponseWithData<DayModeTvGuide>>(`${baseUrl}tv-guided-look/day-mode`, request);

    return response;
}

export const downloadTvGuidePdf = async(playerId: Guid, start: string, end: string) : Promise<{data: Blob, filename: string}> => {
    const params = new GetParams();
    params.Add("playerId", playerId);
    params.Add("startTime", start);
    params.Add("endTime", end);
    const response: AxiosResponse<Blob> = await axios.get(`${baseUrl}tv-guided-look/pdf${params.GetParams()}`, {
        headers: {
            'Authorization': getToken()
        },
        responseType: 'blob'
    });
    const result = {
        data: response.data,
        filename: `TV_Guide_${start}_${end}.pdf`
    };

    return result;
}
